import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { appHeader_template } from "../components/templates/appHeader_template";
import { vnApp_leadpilot } from "../components/vnApp_leadpilot";
import { SIDEBAR_STATE_CLASS, store } from "~/state/store";
const MOBILE_MENU_DATA_ATTR = "data-mobile-menu";
const MOBILE_MENU_STATE = {
    hidden: "hidden",
    visible: "visible",
};
const HEADER_SIDEBAR_HIDDEN_STATE = "hidden";
export class header extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this.unsubscribeThemeState = null;
        this.unsubscribeMobileMenuState = null;
        this.unsubscribeSidebarState = null;
    }
    getModuleName() {
        return "header";
    }
    buildContent() {
        let vnApp = this.getVnAppZone().app;
        //
        // Only if were logged in
        if (vnApp.loggedUser != null && vnApp.loggedUser.isLoggedIn) {
            this.appHeader = new appHeader_template("mainHeader", this.viewModel, this);
            this.appHeader.setUser(vnApp.loggedUser);
            let isUsersVisible = this.hasAccessToSection(vnApp_leadpilot.SECTION_ID_USER_OTHERS, vnApp_leadpilot.ACCESS_TYPE_READ);
            let isLogsVisible = this.hasAccessToSection(vnApp_leadpilot.SECTION_ID_LOG, vnApp_leadpilot.ACCESS_TYPE_READ);
            let isRolesVisible = this.hasAccessToSection(vnApp_leadpilot.SECTION_ID_ROLE, vnApp_leadpilot.ACCESS_TYPE_READ);
            let isTasksVisible = this.hasAccessToSection(vnApp_leadpilot.SECTION_ID_TASK, vnApp_leadpilot.ACCESS_TYPE_READ);
            this.appHeader.setIsUsersVisible(isUsersVisible);
            this.appHeader.setIsLogsVisible(isLogsVisible);
            this.appHeader.setIsRolesVisible(isRolesVisible);
            this.appHeader.getTemplateViewModel().isTasksVisible(isTasksVisible);
            this.appHeader.getTemplateViewModel().isSettingsVisible((isUsersVisible || isLogsVisible || isRolesVisible || isTasksVisible));
            const appHeaderElement = this.appHeader.build();
            this.bindThemeState();
            this.bindMobileMenuState();
            this.bindSidebarState();
            return [appHeaderElement];
        }
        else {
            this.unsubscribeFromThemeState();
            this.unsubscribeFromMobileMenuState();
            this.unsubscribeFromSidebarState();
            this.clearMainMobileMenuState();
            this.clearHeaderSidebarState();
            return [document.createElement("div")];
        }
    }
    fillPage() {
    }
    cleanup() {
        this.unsubscribeFromThemeState();
        this.unsubscribeFromMobileMenuState();
        this.unsubscribeFromSidebarState();
        this.clearMainMobileMenuState();
        this.clearHeaderSidebarState();
    }
    logOut() {
        let _mythis = this;
        // loading the page if the user is logged in
        let loginReq_url = '/api/access/logout/';
        let loginReq_Params = [];
        let XHRHdl = new XMLHttpRequestHandler(loginReq_url, loginReq_Params, this);
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                if (req.request.readyState == 4) {
                    if (req.request.status == 200) {
                        page.redirect('/');
                    }
                }
            };
        });
        XHRHdl.execute();
    }
    setHeaderTitle(title) {
        this.appHeader.setHeaderTitle(title);
        this.appHeader.setBreadcrumbs(this.getDefaultBreadcrumbs(title));
    }
    setBreadcrumbs(breadcrumbs) {
        this.appHeader.setBreadcrumbs(breadcrumbs);
    }
    getDefaultBreadcrumbs(currentTitle) {
        const pathname = window.location.pathname;
        const recruitingPaths = [
            "/question_banks",
            "/partners",
            "/creatives",
            "/contracts",
            "/transmissions",
        ];
        if (pathname.startsWith("/admin_") || pathname.startsWith("/admin/") || recruitingPaths.includes(pathname)) {
            const breadcrumbs = [
                { label: "Home", href: "/home", icon: "home" },
                { label: "Recruiting", href: null },
            ];
            if (currentTitle) {
                breadcrumbs.push({ label: currentTitle, href: null });
            }
            return breadcrumbs;
        }
        return [];
    }
    viewProfile(idUser) {
        page(`/users/profile/${idUser}`);
    }
    bindThemeState() {
        this.unsubscribeFromThemeState();
        this.unsubscribeThemeState = store.subscribe((state) => state.theme, (theme) => {
            this.appHeader?.setTheme(theme);
        }, { fireImmediately: true });
    }
    unsubscribeFromThemeState() {
        this.unsubscribeThemeState?.();
        this.unsubscribeThemeState = null;
    }
    bindMobileMenuState() {
        this.unsubscribeFromMobileMenuState();
        this.unsubscribeMobileMenuState = store.subscribe((state) => state.isMobileMenuOpen, (isOpen) => {
            this.appHeader?.setMobileMenuOpen(isOpen);
            this.setMainMobileMenuState(isOpen);
        }, { fireImmediately: true });
    }
    unsubscribeFromMobileMenuState() {
        this.unsubscribeMobileMenuState?.();
        this.unsubscribeMobileMenuState = null;
    }
    bindSidebarState() {
        this.unsubscribeFromSidebarState();
        this.unsubscribeSidebarState = store.subscribe((state) => state.isSidebarOpen, (isOpen) => {
            this.appHeader?.setSidebarState(isOpen
                ? SIDEBAR_STATE_CLASS.expanded
                : SIDEBAR_STATE_CLASS.collapsed);
        }, { fireImmediately: true });
    }
    unsubscribeFromSidebarState() {
        this.unsubscribeSidebarState?.();
        this.unsubscribeSidebarState = null;
    }
    setMainMobileMenuState(isOpen) {
        const appMain = this.getAppMain();
        if (!appMain) {
            return;
        }
        appMain.setAttribute(MOBILE_MENU_DATA_ATTR, isOpen
            ? MOBILE_MENU_STATE.visible
            : MOBILE_MENU_STATE.hidden);
    }
    clearMainMobileMenuState() {
        this.setMainMobileMenuState(false);
    }
    clearHeaderSidebarState() {
        this.appHeader?.setSidebarState(HEADER_SIDEBAR_HIDDEN_STATE);
    }
    getAppMain() {
        return document.querySelector(".app-main");
    }
}
